import { ReactNode } from "react";

import { Box } from "@/components/layout/flexbox";

export function DialogSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  return (
    <Box mb={20}>
      <Box fontWeight={600} fontSize={16}>
        {title}
      </Box>
      {description && <Box>{description}</Box>}
      <Box pt={12}>{children}</Box>
    </Box>
  );
}
